module.exports = __webpack_public_path__ + "img/authore.779b5ead.svg";